import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class CompletedDateColumn extends Column {
    title = 'training.completionDate';
    property = 'completedAt';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
